<h5  align="left">
  Split Details
</h5>
<mat-dialog-content class="mat-typography" >
<div *ngFor="let split of bookingRequests">
  <br>
  <div class="row" >
    <div class="col"  align="left">
     <strong>Split Customer: {{split.customerInfo.nameId}} - {{split.customerInfo.name}}</strong>
    </div>
     <br>
  </div>
  <div class="row" *ngIf="split.bookingItems && split.bookingItems.length > 0">
    <div class="col">
      <mat-table class="table table-sm" #table2 [dataSource]="split.dataSource">

        <ng-container matColumnDef="categoryType">
          <mat-header-cell *matHeaderCellDef class="text-left"> Type </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.categoryType}}</small>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef class="text-left"> Name </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.name}}</small>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <mat-header-cell *matHeaderCellDef class="text-left"> Quantity </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.quantity}}</small>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="percentage">
          <mat-header-cell *matHeaderCellDef class="text-left"> Split % </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.percentage}}</small>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef class="text-left"> Total </mat-header-cell>
          <mat-cell *matCellDef="let item" class="text-left">
            <small> {{item.amount}}</small>
          </mat-cell>
        </ng-container>

        <mat-header-row scope="row" style="padding:0px;min-height:20px;" *matHeaderRowDef="displayedColumnsSplits">
        </mat-header-row>
        <mat-row scope="row" style="padding:0px;min-height:20px;" *matRowDef="let row; columns: displayedColumnsSplits;">
        </mat-row>
      </mat-table>
    </div>
  </div>
  <div align="center" *ngIf="!split.bookingItems || split.bookingItems.length ==  0" >
   <small>No items were found that match the split details.</small> 
  </div>
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="ta-splits-close mat-stroked-button-WhiteBackground-GreenText ta-customer-openbooking magin_5 color_green" [mat-dialog-close]="false">Close</button>
</mat-dialog-actions>
